import {AppThunk} from '..';
import {AuthorizeEsiaResponsePayload} from '../../../shared/models/api/authorizeEsiaResponsePayload';
import {SnackbarNotificationType} from '../../../shared/components/snackbar/model';
import {storage, StorageKeys} from '../../../shared/storage';
import {
  CardReissueEsiaAttempt,
  isCardReissueEsiaAttemptCurrent,
  loadCardReissueExpectedSnils,
  stopCardReissueEsiaPending,
} from '../../../shared/storage/cardReissueEsia';
import {isEsiaSnilsMatching} from '../../../shared/utils/isEsiaSnilsMatching';
import {addNotification} from '../snackbar';
import {getHolderProfile} from '../profile';
import {enterServerPendingCardActivation} from '../cardActivation';

export const showEsiaMismatchAlert = (): AppThunk => {
  return (dispatch) => {
    dispatch(
      addNotification({
        message:
          'Данные учётной записи ЕСИА не совпадают с данными держателя карты. Войдите через Госуслуги под своей учётной записью.',
        type: SnackbarNotificationType.Error,
      }),
    );
  };
};

export const blockReissueIfAlreadySubmitted = (): AppThunk<boolean> => {
  return async (dispatch) => {
    const switchedToActivation = await dispatch(enterServerPendingCardActivation());
    if (!switchedToActivation) {
      return false;
    }

    dispatch(
      addNotification({
        message: 'Заявление на перевыпуск уже создано',
        type: SnackbarNotificationType.Error,
      }),
    );
    return true;
  };
};

export const assertSamePerson = (
  esiaRegInfo: AuthorizeEsiaResponsePayload,
  expectedSnils?: string | null,
): AppThunk<boolean> => {
  return async (dispatch, getState) => {
    if (expectedSnils === null) return true;

    const expected = expectedSnils === undefined ? await loadCardReissueExpectedSnils() : expectedSnils;
    let ok = expected
      ? isEsiaSnilsMatching(esiaRegInfo, expected)
      : isEsiaSnilsMatching(esiaRegInfo, getState().profile.holder);

    if (!expected && !getState().profile.holder?.snils) {
      await dispatch(getHolderProfile());
      ok = isEsiaSnilsMatching(esiaRegInfo, getState().profile.holder);
    }

    return ok;
  };
};

export const prepareCardReissueAfterEsia = (
  isSamePerson: boolean,
  res: AuthorizeEsiaResponsePayload,
  attempt?: CardReissueEsiaAttempt,
): AppThunk => {
  return async () => {
    if (!isSamePerson || (attempt && !isCardReissueEsiaAttemptCurrent(attempt))) {
      return;
    }

    await stopCardReissueEsiaPending();
    if (attempt && !isCardReissueEsiaAttemptCurrent(attempt)) return;

    if (res.token) {
      await storage.setItem(StorageKeys.activationToken, res.token);
    }
  };
};
